import { createReducer } from 'reduxsauce'
import { INITIAL_STATE } from './initialState'
import { TariffTypes } from './Actions'
import RequestState from 'Enums/RequestState'

export const fetchTariffListLoading = (state) => {
  return {
    ...state,
    fetchTariffListRequestState: RequestState.LOADING,
  }
}
export const fetchTariffListLoadingMore = (state) => {
  return {
    ...state,
    fetchTariffListRequestState: RequestState.LOADING_MORE,
  }
}
export const fetchTariffListSuccess = (
  state,
  { offset, tariffs, nextOffset },
) => {
  let result = []
  for (let j = 0; j < tariffs.length; j++) {
    if (!state.tariffs.some((tariff) => tariff._id === tariffs[j]._id)) {
      result.push(tariffs[j])
    }
  }
  if (offset === 0) {
    return {
      ...state,
      fetchTariffListRequestState: RequestState.SUCCEEDED,
      tariffsPaginationOffset: nextOffset,
      tariffs: [...tariffs],
    }
  } else {
    return {
      ...state,
      fetchTariffListRequestState: RequestState.SUCCEEDED,
      tariffsPaginationOffset: nextOffset,
      tariffs: [...state.tariffs, ...result],
    }
  }
}
export const fetchTariffListFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchTariffListRequestState: requestState,
  }
}
export const createTariffLoading = (state) => {
  return {
    ...state,
    createTariffRequestState: RequestState.LOADING,
  }
}
export const createTariffSuccess = (state, { tariff }) => {
  return {
    ...state,
    createTariffRequestState: RequestState.SUCCEEDED,
    tariffs: [tariff, ...state.tariffs],
    count: state.count + 1,
  }
}
export const createTariffFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    createTariffRequestState: requestState,
  }
}
export const updateTariffLoading = (state) => {
  return {
    ...state,
    updateTariffRequestState: RequestState.LOADING,
  }
}
export const updateTariffSuccess = (state, { tariff }) => {
  const updatedTariffs = state.tariffs.map((item) =>
    item._id === tariff._id ? tariff : item,
  )
  return {
    ...state,
    updateTariffRequestState: RequestState.SUCCEEDED,
    tariffs: updatedTariffs,
  }
}
export const updateTariffFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    updateTariffRequestState: requestState,
  }
}
export const deleteTariffLoading = (state) => {
  return {
    ...state,
    deleteTariffRequestState: RequestState.LOADING,
  }
}

export const deleteTariffSuccess = (state, { tariffID }) => {
  const filteredTariffs = state.tariffs.filter((item) => item._id !== tariffID)
  return {
    ...state,
    deleteTariffRequestState: RequestState.SUCCEEDED,
    tariffs: filteredTariffs,
    count: state.count - 1 < 0 ? 0 : state.count - 1,
  }
}

export const deleteTariffFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    deleteTariffRequestState: requestState,
  }
}
export const fetchTariffsCountLoading = (state) => {
  return {
    ...state,
    fetchTariffsCountRequestState: RequestState.LOADING,
  }
}
export const fetchTariffsCountSuccess = (state, { count }) => {
  return {
    ...state,
    fetchTariffsCountRequestState: RequestState.SUCCEEDED,
    count: count,
  }
}
export const fetchTariffsCountFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchTariffsCountRequestState: requestState,
  }
}
export const resetTariffs = (state) => {
  return {
    ...state,
    tariffs: [],
    tariffsPaginationOffset: 0,
    fetchTariffListRequestState: RequestState.UNINITIALIZED,
  }
}
export const resetFilter = (state) => {
  return {
    ...state,
    filter: state.tariffFilter,
  }
}

export const reducer = createReducer(INITIAL_STATE, {
  [TariffTypes.FETCH_TARIFF_LIST_LOADING]: fetchTariffListLoading,
  [TariffTypes.FETCH_TARIFF_LIST_LOADING_MORE]: fetchTariffListLoadingMore,
  [TariffTypes.FETCH_TARIFF_LIST_SUCCESS]: fetchTariffListSuccess,
  [TariffTypes.FETCH_TARIFF_LIST_FAIL]: fetchTariffListFail,
  [TariffTypes.CREATE_TARIFF_LOADING]: createTariffLoading,
  [TariffTypes.CREATE_TARIFF_SUCCESS]: createTariffSuccess,
  [TariffTypes.CREATE_TARIFF_FAIL]: createTariffFail,
  [TariffTypes.UPDATE_TARIFF_LOADING]: updateTariffLoading,
  [TariffTypes.UPDATE_TARIFF_SUCCESS]: updateTariffSuccess,
  [TariffTypes.UPDATE_TARIFF_FAIL]: updateTariffFail,
  [TariffTypes.DELETE_TARIFF_LOADING]: deleteTariffLoading,
  [TariffTypes.DELETE_TARIFF_SUCCESS]: deleteTariffSuccess,
  [TariffTypes.DELETE_TARIFF_FAIL]: deleteTariffFail,
  [TariffTypes.FETCH_TARIFFS_COUNT_LOADING]: fetchTariffsCountLoading,
  [TariffTypes.FETCH_TARIFFS_COUNT_SUCCESS]: fetchTariffsCountSuccess,
  [TariffTypes.FETCH_TARIFFS_COUNT_FAIL]: fetchTariffsCountFail,
  [TariffTypes.RESET_TARIFFS]: resetTariffs,
  [TariffTypes.RESET_FILTER]: resetFilter,
})
